module.exports = __webpack_public_path__ + "img/menu-icon.39f1cd03.svg";